export default "__VITE_ASSET__BtBehIO6__"